export const getRewardsContractAddress = ({ app: { rewardsContractAddress } }) =>
  rewardsContractAddress;

export const getCatTokenAddress = ({ app: { catTokenAddress } }) => catTokenAddress;

export const getCspcAddress = ({ app: { catPaymentContractAddress } }) => catPaymentContractAddress;

export const getAppUrl = ({ app: { appUrl } }) => appUrl;



// WEBPACK FOOTER //
// ./src/selectors/app.js